<template>
  <div class="page_container">
    <div class="banner">
      <img src="../../assets/images/brandIncrease_banner.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon3">
        <i class="iconfont icon-pinpaizichanpingtai"></i>
      </div>
      <div class="breadcrumb_item">辅助功能&内容管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">买手图文设置</div>
    </div>

    <div class="form_wrap">
      <div class="state">
        <h1>图文审核状态：</h1>
        <van-radio-group
          v-model="formData.checkstate"
          class="flex-around state_radio"
        >
          <van-radio name="待审核" checked-color="#ee0a24">待审核</van-radio>
          <van-radio name="已审核" checked-color="#ee0a24">已审核</van-radio>
        </van-radio-group>
      </div>

      <div class="state">
        <h1>图文显示状态：</h1>
        <van-radio-group
          v-model="formData.at_state"
          class="flex-around state_radio"
        >
          <van-radio name="显示" checked-color="#ee0a24">显示</van-radio>
          <van-radio name="隐藏" checked-color="#ee0a24">隐藏</van-radio>
        </van-radio-group>
      </div>

      <div class="primary-button" @click="query">保存确认</div>
      <div class="primary-button return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i> 返回
      </div>
    </div>
  </div>
</template>

<script>
import { encryptstringview } from "../../api/api";
import { getArticleDetail, editArticle } from "../../api/article";
import { mapState } from "vuex";
export default {
  name: "articleEdit",
  data() {
    return {
      qyid: 0,
      id: "",

      loading: false,
      formData: {
        id: "",
        slid: "",
        checkstate: "",
        at_state: "",
      },
      creenIndex: "",
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        if (id) {
          this.formData.id = id;
          this.init(id);
        }
      } else {
        this.$router.back();
      }
    },

    init(id) {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getArticleDetail({ id }).then((res) => {
        this.formData.slid = res.slid;
        this.formData.checkstate = res.checkstate;
        this.formData.at_state = res.at_state;
        Toast.clear();
      });
    },

    handleReturn() {
      history.back();
    },

    query() {
      let { formData } = this;
      if (formData.checkstate == "") {
        this.$toast("请选择图文审核状态");
        return;
      }
      if (formData.at_state == "") {
        this.$toast("请选择图文显示状态");
        return;
      }
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      editArticle(formData).then((res) => {
        Toast.clear();
        if (res.result) {
          this.$toast.success(res.message);
          setTimeout(() => {
            history.back();
          }, 1500);
        } else {
          this.$toast.fail(res.message);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.page_container {
  .form_wrap {
    padding: 116px 75px 340px;
    h1 {
      font-size: 30px;
      color: #444444;
      margin-bottom: 35px;
      text-align: center;
      font-weight: 400;
    }
    .state {
      margin-bottom: 100px;
      /deep/ .van-radio__label {
        font-size: 14px;
      }
    }
  }
}
</style>